import RestService from "./RestService";

export default class UserSearchService extends RestService {
  constructor() {
    super("/api/usersearch");
  }
}
